import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { productData } from "../globalApi/Api";
import PopupModel from "../popupmodel/PopupModel";
import Select from "react-select";
import Images from "../../assests/Images";
import moment from "moment";

const NewPurchase = () => {
  const { state } = useLocation();
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      vendorDetails: [
        {
          product: "",
          quantity: "",
          quantityType: "",
          otherQuantityType: "",
          productFor: "",
          unitPrice: "",
          price: "",
          salesDate: moment().format("YYYY-MM-DD"),
          hsncode: "",
          gstPercentage: "",
          manufacturingDate: "",
          expiryDate: "",
          lowLevelCustomer: "",
          midLevelCustomer: "",
          highLevelCustomer: "",
          others: "",
          stock: "Available",
        },
      ],
      purchaseDate: moment().format("YYYY-MM-DD"),
      transactionMode: "Online",
      transactionStatus: "Pending",
    },
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "vendorDetails",
  });

  const vendorDetails = useWatch({ name: "vendorDetails", control });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/invoicesnew`,
          postData
        );

        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add purchase",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to add purchase. Please try again.");
      },
    }
  );
  //

  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/invoicesnew/${state?.id}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error updating purchase:", error);
        throw error; // re-throw to trigger onError
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add purchase",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to update the executive. Please try again.");
      },
    }
  );

  // SETVALUE FOR STATE VALUE

  useEffect(() => {
    if (state) {
      setValue(
        "purchaseDate",
        state?.purchaseDate
          ? moment(state?.purchaseDate).format("YYYY-MM-DD")
          : ""
      );
      setValue("transactionMode", state?.transactionMode || "");
      setValue("transactionStatus", state?.transactionStatus || "");
      setValue("invoiceNumber", state?.invoiceNumber || "");
      // setValue("orderProducts", state?.orderProducts || []);

      if (state?.vendorDetails?.length > 0) {
        replace(
          state?.vendorDetails?.map((item) => ({
            product: item?.product || null,
            quantity: item?.quantity || null,
            unitPrice: item?.unitPrice || null,
            quantityType: item?.quantityType || null,
            productFor: item?.productFor || null,
            salesDate: item?.salesDate || null,

            hsncode: item?.hsncode || null,
            gstPercentage: item?.gstPercentage || null,
            manufacturingDate: item?.manufacturingDate || null,
            expiryDate: item?.expiryDate || null,
            lowLevelCustomer: item?.lowLevelCustomer || null,
            midLevelCustomer: item?.midLevelCustomer || null,
            highLevelCustomer: item?.highLevelCustomer || null,
            others: item?.others || null,
            stock: item?.stock || null,
          }))
        );
      }
    }
  }, [state, setValue, replace]);

  // GET API START FOR PRODUCT
  const {
    data: productDetails,
    isLoading: productLoading,
    refetch: productRefetch,
  } = useQuery("product", productData, {
    refetchOnWindowFocus: false,
  });

  // GET API END FOR PRODUCT

  let products = productDetails?.data;

  const productOptions = products?.map((product) => ({
    label: product?.productNameEnglish,
    value: product?.productNameEnglish,
  }));

  // SETVALUE FOR QUANITYTYPE AND UNITPRICE

  // useEffect(() => {
  //   if (!vendorDetails || !Array.isArray(vendorDetails)) return;

  //   vendorDetails?.forEach((item, index) => {
  //     const selectedProduct = products?.find(
  //       (product) => product?.productNameEnglish === item?.product
  //     );

  //     console.log("selected product", selectedProduct)

  //     if (selectedProduct) {
  //       if (item?.quantityType !== selectedProduct?.quantityType) {
  //         setValue(
  //           `vendorDetails.${index}.quantityType`,
  //           selectedProduct?.quantityType || ""
  //         );
  //       }
  //     } else {
  //       if (item?.quantityType) {
  //         setValue(`vendorDetails.${index}.quantityType`, "");
  //       }
  //     }
  //   });
  // }, [vendorDetails, products, setValue]);

  // FORM SUBMBIT
  const onSubmit = (data) => {
    const isoPurchaseDate = moment(data?.purchaseDate, "YYYY-MM-DD")
      .startOf("day")
      .toISOString();
    let formData = {
      invoiceNumber: data?.invoiceNumber,
      transactionMode: data?.transactionMode,
      transactionStatus: data?.transactionStatus,
      purchaseDate: isoPurchaseDate,
      vendorDetails: vendorDetails,
    };

    if (state?.id) {
      updateApi(formData);
    } else {
      mutate(formData);
    }
  };

  return (
    <>
      <div className="form_main_block">
        <div className="form_sub_block">
          <form className="p-4" onSubmit={handleSubmit(onSubmit)}>
            {fields?.map((field, index) => {
              return (
                <>
                  <div key={field?.id}>
                    <div className="row px-3 d-flex gap-3 my-2 append_order">
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-0 p-0">
                        <label className="executive_label">
                          Product Name&nbsp;
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <Controller
                          name={`vendorDetails.${index}.product`}
                          control={control}
                          rules={{ required: "Product is required" }}
                          render={({ field, fieldState: { error } }) => (
                            <div style={{ marginBottom: "1rem" }}>
                              <Select
                                {...field}
                                options={productOptions}
                                placeholder="Select Product"
                                isClearable
                                value={
                                  productOptions?.find(
                                    (o) => o.value === field.value
                                  ) || null
                                }
                                onChange={(selectedOption) => {
                                  const selectedValue =
                                    selectedOption?.value || "";
                                  field.onChange(selectedValue); // RHF: update product field

                                  // Try to locate full product record
                                  const matchedProduct = products?.find(
                                    (p) =>
                                      p.productNameEnglish === selectedValue
                                  );

                                  if (matchedProduct) {
                                    // Auto‑fill every linked field you care about
                                    // setValue(`vendorDetails.${index}.quantityType`, matchedProduct?.quantityType ?? "");
                                    // setValue(`vendorDetails.${index}.unitPrice`, matchedProduct?.unitPrice ?? "");
                                    setValue(
                                      `vendorDetails.${index}.hsncode`,
                                      matchedProduct?.hsnCode ?? ""
                                    );
                                    // setValue(`vendorDetails.${index}.gstPercentage`, matchedProduct?.gstAmount ?? "");
                                    // setValue(`vendorDetails.${index}.productFor`, matchedProduct?.productFor ?? "");
                                    setValue(
                                      `vendorDetails.${index}.stock`,
                                      matchedProduct?.stock ?? ""
                                    );
                                    // setValue(`vendorDetails.${index}.highLevelCustomer`, matchedProduct?.highLevelCustomer ?? "");
                                    // setValue(`vendorDetails.${index}.lowLevelCustomer`, matchedProduct?.lowLevelCustomer ?? "");
                                    // setValue(`vendorDetails.${index}.midLevelCustomer`, matchedProduct?.midLevelCustomer ?? "");
                                    // setValue(`vendorDetails.${index}.others`, matchedProduct?.others ?? "");
                                  } else {
                                    // If user cleared / custom entry → wipe linked fields
                                    // setValue(`vendorDetails.${index}.quantityType`, "");
                                    // setValue(`vendorDetails.${index}.unitPrice`, "");
                                    setValue(
                                      `vendorDetails.${index}.hsncode`,
                                      ""
                                    );
                                    // setValue(`vendorDetails.${index}.gstPercentage`, "");
                                    // setValue(`vendorDetails.${index}.productFor`, "");
                                    setValue(
                                      `vendorDetails.${index}.stock`,
                                      ""
                                    );
                                    // setValue(`vendorDetails.${index}.highLevelCustomer`, "");
                                    // setValue(`vendorDetails.${index}.lowLevelCustomer`, "");
                                    // setValue(`vendorDetails.${index}.midLevelCustomer`, "");
                                    // setValue(`vendorDetails.${index}.others`, "");
                                  }
                                }}
                              />

                              {error && (
                                <p className="text-danger small mt-1">
                                  {error?.message}
                                </p>
                              )}
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column  gap-2 mb-0 p-0">
                        <label className="executive_label">HSN Code</label>
                        <Controller
                          name={`vendorDetails.${index}.hsncode`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <>
                              <input
                                {...field}
                                type="text"
                                placeholder="HSN"
                                className="product_input_field"
                                readOnly
                              />
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-0 p-0">
                        <label className="executive_label">
                          Purchase Price<span style={{ color: "red" }}>*</span>
                        </label>
                        <Controller
                          name={`vendorDetails.${index}.unitPrice`}
                          control={control}
                          rules={{ required: "Price is required" }}
                          render={({ field, fieldState: { error } }) => (
                            <>
                              <input
                                {...field}
                                type="number"
                                step="any"
                                placeholder="Unit Price"
                                className="product_input_field"
                              />
                              {error && (
                                <p className="text-danger small">
                                  {error?.message}
                                </p>
                              )}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-0 p-0">
                        <label className="executive_label">
                          Quantity
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Controller
                          name={`vendorDetails.${index}.quantity`}
                          control={control}
                          defaultValue=""
                          rules={{ required: "Quantity is required" }}
                          render={({ field, fieldState: error }) => (
                            <>
                              <input
                                {...field}
                                type="number"
                                step="any"
                                placeholder="Quantity"
                                className="product_input_field"
                              />
                              {error && (
                                <p className="text-danger small">
                                  {error?.message}
                                </p>
                              )}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-0 p-0">
                        <label className="executive_label">Quantity Type<span style={{ color: "red" }}>*</span></label>
                        <Controller
                          name={`vendorDetails.${index}.quantityType`}
                          control={control}
                          defaultValue=""
                          rules={{ required: "Quantity Type is required" }}
                          render={({ field }) => (
                            <select {...field} className="product_input_field">
                              <option value="">Select Quantity Type</option>
                              <option value="PCS">PCS</option>
                              <option value="KG">KG</option>
                              <option value="LTR">LTR</option>
                              <option value="G">G</option>
                              <option value="BOX">BOX</option>
                              <option value="BOXES">BOXES</option>
                              <option value="Other">Other</option>
                            </select>
                          )}
                        />
                      </div>

                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                        <label className="executive_label">Product For</label>
                        <Controller
                          name={`vendorDetails.${index}.productFor`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <select {...field} className="product_input_field">
                              <option value=""> Product For </option>
                              <option value="Sales">Sales</option>
                              <option value="Purchase">Purchase</option>
                              <option value="Both">Both</option>
                            </select>
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column  gap-2 mb-3 p-0">
                        <label className="executive_label">Gst %</label>
                        <Controller
                          name={`vendorDetails.${index}.gstPercentage`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="number"
                              step="any"
                              placeholder="GST"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column  gap-2 mb-3 p-0">
                        <label className="executive_label">
                          Manufacturing Date
                        </label>
                        <Controller
                          name={`vendorDetails.${index}.manufacturingDate`}
                          control={control}
                          defaultValue={null}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              selected={field.value}
                              onChange={(date) => field.onChange(date)}
                              maxDate={new Date()}
                              placeholderText="YYYY-MM-DD"
                              dateFormat="yyyy-MM-dd"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                        <label className="executive_label">Expiry Date</label>
                        <Controller
                          name={`vendorDetails.${index}.expiryDate`}
                          control={control}
                          defaultValue={null}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              selected={field.value}
                              onChange={(date) => field.onChange(date)}
                              minDate={watch(
                                `addProduct.${index}.manufacturingDate`
                              )}
                              placeholderText="YYYY-MM-DD"
                              dateFormat="yyyy-MM-dd"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                        <label className="executive_label">Stock</label>
                        <Controller
                          name={`vendorDetails.${index}.stock`}
                          control={control}
                          defaultValue="Available"
                          render={({ field }) => (
                            <select {...field} className="product_input_field">
                              <option value=""> Stock </option>
                              <option value="Available">Available</option>
                              <option value="Out Of Stock">Out Of Stock</option>
                            </select>
                          )}
                        />
                      </div>
                    </div>
                    <div className="row px-3 d-flex gap-3 my-2 append_order">
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-1 p-0">
                        <label className="executive_label">
                          High Level Customer
                        </label>
                        <Controller
                          name={`vendorDetails.${index}.highLevelCustomer`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder="00.00"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-1 p-0">
                        <label className="executive_label">
                          Mid Level Customer
                        </label>
                        <Controller
                          name={`vendorDetails.${index}.midLevelCustomer`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder="00.00"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-1 p-0">
                        <label className="executive_label">
                          Low Level Customer
                        </label>
                        <Controller
                          name={`vendorDetails.${index}.lowLevelCustomer`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder="00.00"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>
                      {/* <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-1 p-0">
                        <label className="executive_label">Others</label>
                        <Controller
                          name={`vendorDetails.${index}.others`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder="00.00"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div> */}
                      <div
                        className="col-12 col-md-2 d-flex  justify-content-start align-items-end gap-2 mb-1 p-0"
                        style={{ width: "8%" }}
                        onClick={() => {
                          append({
                            product: "",
                            quantity: "",
                            unitPrice: "",
                            discountPrice: "",
                            actualPrice: "",
                            hsnCode: "",
                            gstPercentage: "",
                            manufacturingDate: "",
                            expiryDate: "",
                            lowLevelCustomer: "",
                            midLevelCustomer: "",
                            highLevelCustomer: "",
                            others: "",
                            stock: "",
                          });
                        }}
                      >
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            cursor: "pointer",
                          }}
                        >
                          {" "}
                          <img
                            src={Images?.orderAdd}
                            alt="no-image"
                            className="image_icon"
                          />
                        </div>
                      </div>
                      {index > 0 ? (
                        <>
                          <button
                            onClick={() => {
                              remove(index);
                            }}
                            style={{
                              border: "none",
                              borderRadius: "5px",
                              height: "35px",
                              fontWeight: "bolder",
                              background: "grey",
                            }}
                          >
                            Remove
                          </button>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </>
              );
            })}

            <div className="row px-3 d-flex gap-3 my-4">
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Purchase Date</label>
                <Controller
                  name="purchaseDate"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className="product_input_field"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Invoice No</label>
                <Controller
                  name="invoiceNumber"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Invoice No"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Transaction Mode</label>
                <Controller
                  name="transactionMode"
                  control={control}
                  defaultValue="Online"
                  render={({ field }) => (
                    <select {...field} className="product_input_field">
                      <option value="">None</option>
                      <option value="Cash">Cash</option>
                      <option value="Online">Online</option>
                    </select>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Status</label>
                <Controller
                  name="transactionStatus"
                  control={control}
                  defaultValue="Pending"
                  render={({ field }) => (
                    <select {...field} className="product_input_field">
                      <option value="">None</option>
                      <option value="Pending">Pending</option>
                      <option value="Completed">Completed</option>
                    </select>
                  )}
                />
              </div>
            </div>

            <div className="row px-3 my-4">
              <div className="col-12 col-md-2 p-0">
                <button className="product_form_submit_btn">
                  {postLoading || putLoading ? (
                    <>
                      <i class="fa fa-spinner fa-spin"></i>
                    </>
                  ) : (
                    <>Submit</>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <PopupModel
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        message="Purchase Added Successfully!"
        updatemessage="Purchase Updated Successfully!"
        state={state?.id}
        navigateUrl="/viewPurchase"
      />
    </>
  );
};

export default NewPurchase;
